import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Sparkles, Droplets, BookOpen, Coffee, ListChecks } from 'lucide-react';
export function TheSolution() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  const deliverables = [{
    icon: <BookOpen className="w-6 h-6 text-gold-500" data-id="element-138" />,
    title: 'Guía Paso a Paso del Protocolo',
    desc: 'Instrucciones claras para la Fase de Purga y Fase de Sellado durante las 48 horas.'
  }, {
    icon: <Droplets className="w-6 h-6 text-gold-500" data-id="element-139" />,
    title: 'Tutorial de Automasaje Linfático',
    desc: 'Técnica de bombeo abdominal de 10 minutos para guiar el líquido estancado.'
  }, {
    icon: <Coffee className="w-6 h-6 text-gold-500" data-id="element-140" />,
    title: 'Recetario de Elixires Anti-Cortisol',
    desc: 'Infusiones caseras específicas para frenar la inflamación y calmar el sistema nervioso.'
  }, {
    icon: <CheckCircle2 className="w-6 h-6 text-gold-500" data-id="element-141" />,
    title: 'Plan de Alimentación de Emergencia',
    desc: "Menú exacto de 'Carga Limpia' sin fibra fermentable para evitar gases."
  }, {
    icon: <ListChecks className="w-6 h-6 text-gold-500" data-id="element-142" />,
    title: 'Checklist de Errores Críticos',
    desc: 'Lo que debes evitar a toda costa 24 horas antes de tu evento importante.'
  }];
  return <section className="py-20 px-4 bg-sage-500 text-white relative overflow-hidden" data-id="element-143">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-sage-400 rounded-full mix-blend-multiply filter blur-3xl opacity-50 translate-x-1/2 -translate-y-1/2" data-id="element-144"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-forest rounded-full mix-blend-multiply filter blur-3xl opacity-20 -translate-x-1/2 translate-y-1/2" data-id="element-145"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-146">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="text-center mb-16" data-id="element-147">
          <motion.div variants={itemVariants} className="inline-flex items-center justify-center space-x-2 bg-white/10 px-4 py-2 rounded-full mb-6 backdrop-blur-sm" data-id="element-148">
            <Sparkles className="w-5 h-5 text-gold-400" data-id="element-149" />
            <span className="font-semibold tracking-wide text-sm uppercase" data-id="element-150">
              El Secreto Revelado
            </span>
          </motion.div>

          <motion.h2 variants={itemVariants} className="text-4xl md:text-5xl font-bold font-playfair mb-6 text-white" data-id="element-151">
            El Mecanismo de Descompresión Dual
          </motion.h2>

          <motion.p variants={itemVariants} className="text-lg md:text-xl text-sage-100 max-w-3xl mx-auto leading-relaxed" data-id="element-152">
            Este protocolo no es una dieta, es una{' '}
            <strong className="text-white font-bold" data-id="element-153">
              intervención bioquímica de 48 horas
            </strong>
            . Primero, utilizamos infusiones adaptógenas específicas para
            "engañar" al sistema nervioso y bajar los niveles de cortisol
            instantáneamente. Segundo, aplicamos técnicas de drenaje linfático
            manual que tú misma puedes hacer en 10 minutos para guiar
            físicamente el líquido estancado hacia las vías de salida naturales.
          </motion.p>

          <motion.p variants={itemVariants} className="text-xl font-playfair italic mt-8 text-gold-400" data-id="element-154">
            El resultado es un vientre más plano, una cintura definida y una
            sensación de ligereza real.
          </motion.p>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={containerVariants} className="bg-white text-forest rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-155">
          <motion.h3 variants={itemVariants} className="text-3xl font-bold font-playfair text-center mb-10" data-id="element-156">
            ¿Qué incluye el Protocolo?
          </motion.h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-157">
            {deliverables.map((item, idx) => <motion.div key={idx} variants={itemVariants} className="flex items-start space-x-4" data-id="element-158">
                <div className="flex-shrink-0 bg-cream-100 p-3 rounded-2xl" data-id="element-159">
                  {item.icon}
                </div>
                <div data-id="element-160">
                  <h4 className="font-bold text-lg mb-1" data-id="element-161">{item.title}</h4>
                  <p className="text-forest/70 text-sm leading-relaxed" data-id="element-162">
                    {item.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}